import { ArrowLeft, Home } from "lucide-react";
import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Logo } from "./logo";

type Props = {
  children: ReactNode;
  eyebrow?: string;
  backTo?: string;
  backLabel?: string;
  actions?: ReactNode;
};

export function AppShell({ children, eyebrow, backTo = "/", backLabel = "Natrag", actions }: Props) {
  return (
    <div className="app-layout">
      <header className="app-header">
        <Logo />
        <div className="app-header__actions">
          {actions}
          <Link className="icon-button" to="/" aria-label="Početna">
            <Home aria-hidden="true" />
          </Link>
        </div>
      </header>
      <main id="main" className="app-main">
        <div className="app-context">
          <Link className="back-link" to={backTo}>
            <ArrowLeft aria-hidden="true" />
            {backLabel}
          </Link>
          {eyebrow && <p className="context-label">{eyebrow}</p>}
        </div>
        {children}
      </main>
    </div>
  );
}
